export const EARLY_BIRD_DISCOUNT_CODE = 'EARLYBIRD40';

type EarlyBirdCourseLine = {
  early_bird?: boolean | null;
  dates_tbc?: boolean | null;
  early_bird_label?: string | null;
  early_bird_month?: number | null;
  start?: string | null;
  end?: string | null;
};

export function isEarlyBirdEnrollment(item?: {
  client_data?: {
    early_bird?: boolean | null;
    early_bird_offer?: boolean | null;
  } | null;
  metadata?: EarlyBirdCourseLine[] | null;
  discounts?: Array<{ discount?: { code?: string | null } | null }> | null;
}) {
  if (!item) {
    return false;
  }

  if (item.client_data?.early_bird || item.client_data?.early_bird_offer) {
    return true;
  }

  if (
    Array.isArray(item.metadata) &&
    item.metadata.some((row) => row?.early_bird)
  ) {
    return true;
  }

  return Boolean(
    item.discounts?.some(
      (row) => row?.discount?.code === EARLY_BIRD_DISCOUNT_CODE,
    ),
  );
}

export function formatEnrollmentCourseDate(
  course?: EarlyBirdCourseLine | null,
) {
  if (!course) {
    return '-';
  }

  if (course.dates_tbc || (course.early_bird && !course.start)) {
    return course.early_bird_label || 'Early bird - dates TBC';
  }

  if (course.early_bird && course.dates_tbc) {
    return course.early_bird_label || 'Early bird - dates TBC';
  }

  if (!course.start) {
    return course.early_bird_label || '-';
  }

  return null;
}
